import './App.css';
import { Routes, Route, BrowserRouter } from 'react-router-dom';
import MainLayout from './layouts/MainLayout';
import Dashboard from './pages/Dashboard';
import AuthProvider from './components/AuthProvider';
import axios from 'axios';
import Products from './pages/Products/Products';
import ProductCreate from './pages/Products/Create';

function App() {
  const apiURL = window.location.hostname === 'localhost' ? 'http://localhost:3001/api' : `https://${window.location.hostname}/api`;

  axios.defaults.baseURL = apiURL;
  axios.defaults.withCredentials = true;

  return (
    <BrowserRouter>
      <AuthProvider>
        <MainLayout>
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/products" element={<Products />} />
            <Route path="/products/create" element={<ProductCreate />} />
          </Routes>
        </MainLayout>
      </AuthProvider>
    </BrowserRouter>
  )
}

export default App;
